import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Field from 'components/Field';

export const Container = styled.section`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 16px;
  border: solid 1px ${ColorPalette.HEX.BrightGray};
  background-color: ${({ theme }) => theme.rule.restriction.background};
`;

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.rule.restriction.border};
`;

Header.Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

Header.Title = styled.h5`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme }) => theme.rule.sectionTitle};
`;

export const Body = styled.div`
  padding: 0 16px 24px 16px;
`;

export const StyledField = styled(Field)`
  padding-top: 8px;
`;
